(function () {
  'use strict';

  var starters = [
    { key: 'routine', label: 'Build my full AM & PM routine' },
    { key: 'product', label: 'Is this product right for me?' },
    { key: 'review', label: 'Review what I already use' },
    { key: 'layer', label: 'What can I safely layer together?' },
    { key: 'chat', label: 'Start a conversation with Ask Seyune' }
  ];

  var questions = [
    { key: 'type', prompt: 'What is your skin type?', choices: [['oily', 'Oily'], ['combo', 'Combination'], ['dry', 'Dry'], ['normal', 'Normal']] },
    { key: 'sensitivity', prompt: 'How sensitive is your skin?', choices: [['high', 'Very sensitive'], ['mid', 'Somewhat sensitive'], ['low', 'Not particularly sensitive']] },
    { key: 'goal', prompt: 'What would you like your routine to focus on?', choices: [['sensitive-redness', 'Sensitive + redness'], ['dry-dehydrated', 'Dry + dehydrated']] },
    { key: 'flags', prompt: 'Anything we should consider for safety?', multiple: true, choices: [['pregnant', 'Pregnant or breastfeeding'], ['condition', 'Diagnosed skin condition'], ['makeup', 'I wear makeup'], ['meds', 'Prescription topical medication or skincare'], ['none', 'None of these']] },
  ];

  function node(tag, text, className) {
    var item = document.createElement(tag);
    if (className) item.className = className;
    if (text !== undefined && text !== null) item.textContent = text;
    return item;
  }

  function cloneProfile(profile) {
    var copy = {};
    Object.keys(profile).forEach(function (key) {
      copy[key] = Array.isArray(profile[key]) ? profile[key].slice() : profile[key];
    });
    return copy;
  }

  function getSessionStorage() {
    try { return window.sessionStorage; } catch (error) { return null; }
  }

  function getLocalStorage() {
    try { return window.localStorage; } catch (error) { return null; }
  }

  function init(host) {
    if (host.dataset.ready === '1') return;
    var dialog = host.querySelector('dialog');
    if (!dialog || !window.AskSeyuneRequest || !window.AskSeyuneConsent || !window.AskSeyuneTurnstile) return;
    host.dataset.ready = '1';

    var body = host.querySelector('[data-ask-body]');
    var form = host.querySelector('[data-ask-form]');
    var input = host.querySelector('[data-ask-input]');
    var sendButton = host.querySelector('[data-ask-send]');
    var status = host.querySelector('[data-ask-status]');
    var turnstileHost = host.querySelector('[data-ask-turnstile]');
    var profile = {};
    var activeProfile = null;
    var pendingProfile = null;
    var routineMode = false;
    var history = [];
    var step = 0;
    var busy = false;
    var productContext = null;
    var lastTrigger = null;
    var activeController = null;
    var conversationId = createConversationId();
    var PERSISTENCE_KEY = 'askSeyuneHistory:v1';
    var PERSISTENCE_TTL_MS = 30 * 24 * 60 * 60 * 1000;
    var visibleProducts = [];
    var canonicalProductCache = {};
    var restoredState = false;
    var cartActionBusy = false;
    var cartSnapshot = null;
    var consentStore = window.AskSeyuneConsent.createConsentStore({
      storage: getSessionStorage(),
      key: 'askSeyuneAiConsent',
      version: 'v1'
    });
    var consentGiven = consentStore.hasConsent();
    var adapter = window.AskSeyuneRequest.createAskRequestAdapter({
      endpoint: host.dataset.endpoint
    });

    function trackRoutineEvent(name) {
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish(name, {});
        }
      } catch (error) {}
      try {
        if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: name });
      } catch (error) {}
    }
    var turnstileGate = window.AskSeyuneTurnstile.createTurnstileGate({
      siteKey: host.dataset.turnstileSiteKey,
      host: turnstileHost
    });

    function createConversationId() {
      try { if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID(); } catch (error) {}
      return '';
    }

    function isPersistableConversationId(value) {
      return typeof value === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value);
    }

    function isPersistableHandle(value) {
      return typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,99}$/.test(value);
    }

    function isPersistableVariantId(value) {
      return value === '' || (typeof value === 'string' && /^\d{1,32}$/.test(value));
    }

    function isPersistableCart(value) {
      return value && Number.isInteger(value.item_count) && value.item_count >= 0 &&
        value.item_count <= 10000 &&
        Number.isInteger(value.total_price) && value.total_price >= 0 &&
        typeof value.currency === 'string' && /^[A-Z]{3}$/.test(value.currency);
    }

    function isPersistableMessage(value) {
      return value && (value.role === 'user' || value.role === 'assistant') &&
        typeof value.content === 'string' && value.content.trim() && Array.from(value.content).length <= 500;
    }

    function clonePersistableProfile(value) {
      if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
      var allowed = ['type', 'concerns', 'sensitivity', 'experience', 'flags', 'budget'];
      var safe = {};
      allowed.forEach(function (key) {
        if (Array.isArray(value[key])) {
          if (value[key].length <= 10 && value[key].every(function (entry) { return typeof entry === 'string' && entry.length <= 80; })) safe[key] = value[key].slice();
        } else if (typeof value[key] === 'string' && value[key].length <= 80) {
          safe[key] = value[key];
        }
      });
      return Object.keys(safe).length ? safe : null;
    }

    function persistState() {
      var storage = getLocalStorage();
      if (!storage) return;
      var safeHistory = history.filter(isPersistableMessage).slice(-12).map(function (message) {
        return { role: message.role, content: message.content };
      });
      var safeProfile = clonePersistableProfile(activeProfile);
      var safeConversationId = isPersistableConversationId(conversationId) ? conversationId.toLowerCase() : createConversationId();
      if (safeConversationId) conversationId = safeConversationId;
      var safeProducts = visibleProducts.filter(function (product) {
        return product && isPersistableHandle(product.handle);
      }).slice(0, 12).map(function (product) {
        return {
          handle: product.handle,
          selectedVariantId: isPersistableVariantId(product.selectedVariantId) ? product.selectedVariantId : ''
        };
      });
      var safeCart = isPersistableCart(cartSnapshot) ? {
        item_count: cartSnapshot.item_count,
        total_price: cartSnapshot.total_price,
        currency: cartSnapshot.currency
      } : null;
      try {
        storage.setItem(PERSISTENCE_KEY, JSON.stringify({
          version: 3,
          expiresAt: Date.now() + PERSISTENCE_TTL_MS,
          conversationId: safeConversationId,
          history: safeHistory,
          activeProfile: safeProfile,
          products: safeProducts,
          cart: safeCart
        }));
      } catch (error) {}
    }

    function restorePersistedState() {
      var storage = getLocalStorage();
      if (!storage) return false;
      try {
        var raw = storage.getItem(PERSISTENCE_KEY);
        if (!raw) return false;
        var saved = JSON.parse(raw);
        var supportedVersion = saved && (saved.version === 2 || saved.version === 3);
        var validProducts = supportedVersion &&
          Number.isFinite(saved.expiresAt) && saved.expiresAt > Date.now() &&
          Array.isArray(saved.products) &&
          saved.products.every(function (product) {
            return product && isPersistableHandle(product.handle) && isPersistableVariantId(product.selectedVariantId);
          });
        var validCart = Boolean(saved && (saved.cart === null || isPersistableCart(saved.cart)));
        var validHistory = saved && saved.version === 2 ? true : Boolean(saved && Array.isArray(saved.history) && saved.history.every(isPersistableMessage));
        var persistedProfile = saved && saved.version === 3 ? clonePersistableProfile(saved.activeProfile) : null;
        var validProfile = saved && saved.version === 2 ? true : Boolean(saved && (saved.activeProfile === null || persistedProfile));
        var validId = saved && saved.version === 2 ? true : Boolean(saved && isPersistableConversationId(saved.conversationId));
        if (!validProducts || !validCart || !validHistory || !validProfile || !validId) {
          storage.removeItem(PERSISTENCE_KEY);
          return false;
        }
        history = saved.version === 3 ? saved.history.slice(-12).map(function (message) { return { role: message.role, content: message.content }; }) : [];
        activeProfile = saved.version === 3 ? persistedProfile : null;
        conversationId = saved.version === 3 && saved.conversationId ? saved.conversationId.toLowerCase() : (conversationId || createConversationId());
        visibleProducts = saved.products.slice(0, 12).map(function (product) {
          return { handle: product.handle, selectedVariantId: product.selectedVariantId };
        });
        cartSnapshot = saved.cart ? {
          item_count: saved.cart.item_count,
          total_price: saved.cart.total_price,
          currency: saved.cart.currency
        } : null;
        if (saved.version === 2) persistState();
        return history.length > 0 || visibleProducts.length > 0 || Boolean(cartSnapshot) || Boolean(activeProfile);
      } catch (error) {
        try { storage.removeItem(PERSISTENCE_KEY); } catch (removeError) {}
        return false;
      }
    }

    function clearPersistedState() {
      var storage = getLocalStorage();
      if (!storage) return;
      try { storage.removeItem(PERSISTENCE_KEY); } catch (error) {}
    }

    function setStatus(text, busyState) {
      status.textContent = text || '';
      status.hidden = !text;
      status.setAttribute('aria-busy', busyState ? 'true' : 'false');
    }

    function failureMessage(failureClass, error) {
      var safeClass = failureClass;
      if (!safeClass && error && String(error.code || '').indexOf('turnstile_') === 0) safeClass = 'verification_failed';
      if (safeClass === 'verification_failed') return 'Human verification could not be confirmed. Please try again.';
      if (safeClass === 'request_invalid') return 'I could not validate that request. Please try again.';
      if (safeClass === 'persistence_failed') return 'I could not save that safely right now. Please try again later.';
      return 'I could not complete that safely right now. Please try again later.';
    }

    function updateComposerState() {
      var hasDraft = Boolean(input.value.trim()) || Boolean(pendingProfile);
      sendButton.disabled = busy || !hasDraft;
      sendButton.textContent = busy ? (pendingProfile ? 'Building...' : 'Sending...') : 'Send';
      sendButton.setAttribute('aria-label', sendButton.textContent);
    }

    function appendMessage(text, who) {
      body.appendChild(node('p', text, 'ask-seyune-message ask-seyune-message--' + who));
      body.scrollTop = body.scrollHeight;
    }

    function getShopifyRoot() {
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      return typeof root === 'string' && root ? (root.slice(-1) === '/' ? root : root + '/') : '/';
    }

    function productUrl(handle) {
      return getShopifyRoot() + 'products/' + encodeURIComponent(handle);
    }

    function productJsonUrl(handle) {
      return productUrl(handle) + '.js';
    }

    function cartAddUrl() {
      return window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url
        ? window.Theme.routes.cart_add_url
        : getShopifyRoot() + 'cart/add.js';
    }

    function cartUrl() {
      return window.Theme && window.Theme.routes && window.Theme.routes.cart_url
        ? window.Theme.routes.cart_url
        : getShopifyRoot() + 'cart';
    }

    function formatPresentmentPrice(cents, currency) {
      var amount = Number(cents);
      if (!Number.isFinite(amount)) return '';
      var code = currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CAD';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
          style: 'currency',
          currency: code
        }).format(amount / 100);
      } catch (error) {
        return code + ' ' + (amount / 100).toFixed(2);
      }
    }

    function normalizeRecommendation(product) {
      return {
        handle: product && typeof product.handle === 'string' ? product.handle.trim().toLowerCase() : '',
        role: product && typeof product.role === 'string' ? product.role : '',
        why: product && typeof product.why === 'string' ? product.why : '',
        selectedVariantId: product && typeof product.selectedVariantId === 'string' ? product.selectedVariantId : ''
      };
    }

    async function resolveCanonicalProduct(recommendation) {
      var normalized = normalizeRecommendation(recommendation);
      if (!normalized.handle) throw new Error('product_handle_missing');
      if (canonicalProductCache[normalized.handle]) {
        return Object.assign({}, canonicalProductCache[normalized.handle], {
          role: normalized.role,
          why: normalized.why
        });
      }
      var response = await fetch(productJsonUrl(normalized.handle), {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      if (!response.ok) throw new Error('product_unavailable');
      var product = await response.json();
      if (!product || typeof product.handle !== 'string' || product.handle.trim().toLowerCase() !== normalized.handle) {
        throw new Error('product_handle_mismatch');
      }
      var variants = Array.isArray(product.variants) ? product.variants.filter(function (variant) {
        return variant && variant.available && variant.id;
      }).map(function (variant) {
        return {
          id: String(variant.id),
          title: String(variant.title || ''),
          price: Number(variant.price),
          available: true
        };
      }) : [];
      var selected = variants.length === 1 ? variants[0] : null;
      var images = Array.isArray(product.images) ? product.images : [];
      var state = {
        handle: product.handle.trim().toLowerCase(),
        title: typeof product.title === 'string' && product.title ? product.title : normalized.handle,
        url: productUrl(product.handle.trim().toLowerCase()),
        image: typeof images[0] === 'string' ? images[0] : (typeof product.featured_image === 'string' ? product.featured_image : ''),
        variants: variants,
        selectedVariantId: variants.some(function (variant) { return variant.id === normalized.selectedVariantId; })
          ? normalized.selectedVariantId
          : (selected ? selected.id : ''),
        role: normalized.role,
        why: normalized.why,
        availability: variants.length ? 'available' : 'out_of_stock'
      };
      canonicalProductCache[normalized.handle] = state;
      return state;
    }

    function selectedVariant(state) {
      return state.variants.filter(function (variant) {
        return variant.id === state.selectedVariantId;
      })[0] || null;
    }

    function addableStates(states) {
      return states.filter(function (state) { return selectedVariant(state); });
    }

    function skippedStateLabel(state) {
      var reason = state.availability === 'out_of_stock' ? ' (out of stock)' : ' (choose options)';
      return state.title + reason;
    }
    function cartSectionIds() {
      var ids = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (element) {
        if (element.dataset.sectionId && ids.indexOf(element.dataset.sectionId) === -1) ids.push(element.dataset.sectionId);
      });
      return ids;
    }

    function dispatchCartUpdate(cart, sections) {
      var itemCount = cart && Number(cart.item_count);
      if (!Number.isFinite(itemCount)) itemCount = 0;
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart || {},
          sourceId: 'ask-seyune',
          data: {
            source: 'ask-seyune',
            itemCount: itemCount,
            sections: sections || {}
          }
        }
      }));
    }

    async function fetchCartSummary() {
      var response = await fetch(getShopifyRoot() + 'cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      if (!response.ok) throw new Error('cart_summary_failed');
      return response.json();
    }

    async function addStatesToCart(states, button, resultNode) {
      if (cartActionBusy) return;
      var available = addableStates(states);
      var unavailable = states.filter(function (state) { return !selectedVariant(state); });
      if (!available.length) {
        resultNode.textContent = 'Added 0 items. Skipped ' + unavailable.length + ': ' +
          unavailable.map(skippedStateLabel).join(', ') + '.';
        return;
      }
      cartActionBusy = true;
      button.disabled = true;
      button.textContent = 'Adding...';
      var sections = cartSectionIds();
      var accepted = false;
      try {
        var response = await fetch(cartAddUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            items: available.map(function (state) {
              return { id: Number(selectedVariant(state).id), quantity: 1 };
            }),
            sections: sections.join(','),
            sections_url: window.location.pathname
          })
        });
        var payload = {};
        try { payload = await response.json(); } catch (error) {}
        if (!response.ok) throw new Error('cart_add_failed');
        accepted = true;
        var cart = await fetchCartSummary();
        cartSnapshot = cart;
        dispatchCartUpdate(cart, payload.sections || {});
        button.textContent = 'Added to cart';
        var skippedText = unavailable.length
          ? ' Skipped ' + unavailable.length + ': ' + unavailable.map(skippedStateLabel).join(', ') + '.'
          : '';
        resultNode.textContent = 'Added ' + available.length + ' item' + (available.length === 1 ? '' : 's') + ' to your bag.' + skippedText;
        renderContextChips(body);
      } catch (error) {
        resultNode.textContent = accepted
          ? 'Your bag changed, but I could not confirm the latest totals. Please open your bag to check.'
          : unavailable.length
            ? 'Added 0 items. Skipped ' + unavailable.length + ': ' + unavailable.map(skippedStateLabel).join(', ') + '.'
            : 'I could not add that selection right now. Please try again.';
        if (!accepted) {
          button.disabled = false;
          button.textContent = 'Try again';
        }
      } finally {
        cartActionBusy = false;
      }
    }

    function renderProductCard(container, state, options) {
      options = options || {};
      var card = node('article', null, 'ask-seyune-product-card');
      if (state.image) {
        var image = node('img', null, 'ask-seyune-product-card__image');
        image.src = state.image;
        image.alt = state.title;
        image.loading = 'lazy';
        card.appendChild(image);
      }
      var title = node('h3', null, 'ask-seyune-product-card__title');
      var titleLink = node('a', state.title, 'ask-seyune-product-card__title-link');
      titleLink.href = state.url;
      titleLink.target = '_blank';
      titleLink.rel = 'noopener';
      title.appendChild(titleLink);
      var role = node('p', state.role || 'Considered for your routine.', 'ask-seyune-product-card__role');
      var priceText = state.variants.length === 1
        ? formatPresentmentPrice(state.variants[0].price, state.currency)
        : state.variants.length > 1
          ? 'Available in ' + state.variants.length + ' options'
          : state.availability === 'out_of_stock' ? 'Currently unavailable' : 'Price unavailable';
      var price = node('p', priceText, 'ask-seyune-product-card__price');
      var availabilityText = state.availability === 'out_of_stock'
        ? 'Out of stock'
        : state.availability === 'unknown' ? 'Product details unavailable' : 'Available';
      var availability = node('p', availabilityText, 'ask-seyune-product-card__availability');
      var why = node('p', state.why, 'ask-seyune-product-card__why');
      card.append(title, role, price, availability, why);
      if (state.variants.length > 1) {
        var label = node('label', 'Choose an option', 'ask-seyune-product-card__variant-label');
        var select = node('select', null, 'ask-seyune-product-card__variant');
        select.setAttribute('aria-label', 'Choose an option for ' + state.title);
        var placeholder = node('option', 'Choose an option');
        placeholder.value = '';
        placeholder.disabled = true;
        placeholder.selected = true;
        select.appendChild(placeholder);
        state.variants.forEach(function (variant) {
          var option = node('option', variant.title + ' - ' + formatPresentmentPrice(variant.price, state.currency));
          option.value = variant.id;
          select.appendChild(option);
        });
        select.value = state.selectedVariantId;
        label.appendChild(select);
        card.appendChild(label);
      }
      var view = node('a', 'View product', 'ask-seyune-product-card__link');
      view.href = state.url;
      view.target = '_blank';
      view.rel = 'noopener';
      var actions = node('div', null, 'ask-seyune-product-card__actions');
      if (!options.hideAdd) {
        var addButton = node('button', 'Add to cart', 'ask-seyune-product-card__add');
        addButton.type = 'button';
        addButton.disabled = !selectedVariant(state);
        var result = node('p', '', 'ask-seyune-cart-result');
        if (state.variants.length > 1) {
          var chooser = card.querySelector('.ask-seyune-product-card__variant');
          chooser.addEventListener('change', function () {
            state.selectedVariantId = chooser.value;
            addButton.disabled = !selectedVariant(state);
          });
        }
        addButton.addEventListener('click', function () { addStatesToCart([state], addButton, result); });
        actions.append(addButton, view, result);
      } else {
        actions.appendChild(view);
      }
      card.appendChild(actions);
      container.appendChild(card);
    }

    function renderCommerceFooter(container, states) {
      if (!states.length) return;
      var footer = node('div', null, 'ask-seyune-cart-actions');
      var addAll = node('button', 'Add routine to cart', 'ask-seyune-continue ask-seyune-cart-actions__add');
      addAll.type = 'button';
      var result = node('p', 'Shipping is calculated at checkout.', 'ask-seyune-cart-result');
      addAll.addEventListener('click', function () { addStatesToCart(states, addAll, result); });
      footer.append(addAll, result);
      container.appendChild(footer);
    }

    function routineStates(result) {
      return result.products.map(function (product) {
        var available = product.availability === 'available';
        return {
          handle: product.handle,
          title: product.title,
          url: productUrl(product.handle),
          image: product.image || '',
          variants: available ? [{ id: product.variantId, title: 'Selected option', price: product.priceCents, available: true }] : [],
          selectedVariantId: available ? product.variantId : '',
          currency: result.currency,
          role: product.slot === 'treatment' ? 'Treatment' : product.slot.charAt(0).toUpperCase() + product.slot.slice(1),
          why: product.why,
          availability: product.availability
        };
      });
    }

    function setRoutinePurchaseDisabled(controls, disabled) {
      controls.forEach(function (control) {
        control.disabled = disabled;
      });
    }

    async function addRoutineToCart(states, controls, mode) {
      if (cartActionBusy) return;
      var available = addableStates(states);
      if (states.length !== 3 || available.length !== 3) {
        controls.status.textContent = 'One or more routine products is unavailable, so the routine cannot be added yet.';
        setRoutinePurchaseDisabled(controls.buttons, true);
        return;
      }
      cartActionBusy = true;
      setRoutinePurchaseDisabled(controls.buttons, true);
      controls.status.textContent = mode === 'checkout' ? 'Adding your 3 products before checkout...' : 'Adding your 3 products...';
      try {
        var sections = cartSectionIds();
        var response = await fetch(cartAddUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            items: available.map(function (state) {
              return { id: Number(selectedVariant(state).id), quantity: 1 };
            }),
            sections: sections.join(','),
            sections_url: window.location.pathname
          })
        });
        var payload = {};
        try { payload = await response.json(); } catch (error) {}
        if (!response.ok) throw new Error('routine_cart_add_failed');
        if (mode === 'checkout') {
          window.location.assign('/checkout');
          return;
        }
        var cart = await fetchCartSummary();
        cartSnapshot = cart;
        dispatchCartUpdate(cart, payload.sections || {});
        controls.add.textContent = '3 items added';
        controls.status.textContent = '3 items added. Your routine is ready in your cart.';
        controls.viewCart.hidden = false;
      } catch (error) {
        controls.status.textContent = 'We could not confirm that all 3 products were added. Please check your cart before trying again.';
        setRoutinePurchaseDisabled(controls.buttons, true);
      } finally {
        cartActionBusy = false;
      }
    }

    function renderRoutinePurchaseSummary(container, result, states) {
      var summary = node('section', null, 'ask-seyune-routine-purchase-summary');
      summary.setAttribute('aria-label', 'Routine purchase summary');
      var meta = node('div', null, 'ask-seyune-routine-purchase-summary__meta');
      meta.appendChild(node('p', '3 products', 'ask-seyune-routine-purchase-summary__count'));
      var subtotal = node('div', null, 'ask-seyune-routine-purchase-summary__subtotal');
      subtotal.appendChild(node('span', 'Routine subtotal', 'ask-seyune-routine-purchase-summary__label'));
      subtotal.appendChild(node('strong', formatPresentmentPrice(result.totalPriceCents, result.currency), 'ask-seyune-routine-purchase-summary__amount'));
      meta.appendChild(subtotal);
      meta.appendChild(node('p', 'Includes the current three core products only.', 'ask-seyune-routine-purchase-summary__detail'));
      meta.appendChild(node('p', 'Shipping and taxes calculated at checkout.', 'ask-seyune-routine-purchase-summary__note'));
      var actions = node('div', null, 'ask-seyune-routine-purchase-summary__actions');
      var add = node('button', 'Add all 3', 'ask-seyune-routine-purchase-summary__button ask-seyune-routine-purchase-summary__button--secondary');
      add.type = 'button';
      var checkout = node('button', 'Checkout', 'ask-seyune-routine-purchase-summary__button ask-seyune-routine-purchase-summary__button--primary');
      checkout.type = 'button';
      var viewCart = node('a', 'View cart', 'ask-seyune-routine-purchase-summary__view-cart');
      viewCart.href = cartUrl();
      viewCart.hidden = true;
      var status = node('p', '', 'ask-seyune-routine-purchase-summary__status');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      actions.append(add, checkout, viewCart, status);
      summary.append(meta, actions);
      container.appendChild(summary);
      var controls = { add: add, checkout: checkout, viewCart: viewCart, status: status, buttons: [add, checkout] };
      var complete = states.length === 3 && states.every(function (state) { return Boolean(selectedVariant(state)); });
      if (!complete) {
        status.textContent = 'One or more routine products is unavailable, so the routine cannot be added yet.';
        setRoutinePurchaseDisabled(controls.buttons, true);
      } else {
        add.addEventListener('click', function () {
          trackRoutineEvent('routine_add_all');
          addRoutineToCart(states, controls, 'cart');
        });
        checkout.addEventListener('click', function () {
          trackRoutineEvent('routine_checkout');
          addRoutineToCart(states, controls, 'checkout');
        });
      }
    }

    function renderRoutineResult(container, result) {
      container.replaceChildren();
      var intro = node('p', result.intro, 'ask-seyune-message ask-seyune-message--assistant');
      container.appendChild(intro);
      var states = routineStates(result);
      visibleProducts = states;
      var steps = node('div', null, 'ask-seyune-routine-result__steps');
      states.forEach(function (state, index) {
        steps.appendChild(node('span', 'Step ' + (index + 1) + ' · ' + state.role, 'ask-seyune-routine-result__step'));
      });
      container.appendChild(steps);
      var productGrid = node('div', null, 'ask-seyune-products ask-seyune-routine-products');
      states.forEach(function (state) { renderProductCard(productGrid, state, { hideAdd: true }); });
      container.appendChild(productGrid);
      if (Number.isInteger(result.totalPriceCents) && result.totalPriceCents >= 0 && result.currency === 'CAD') {
        renderRoutinePurchaseSummary(container, result, states);
      } else {
        var unavailableSummary = node('p', 'This routine total could not be verified, so checkout is unavailable.', 'ask-seyune-routine-purchase-summary__status');
        unavailableSummary.setAttribute('role', 'status');
        unavailableSummary.setAttribute('aria-live', 'polite');
        container.appendChild(unavailableSummary);
      }
      if (result.fallbackReason) trackRoutineEvent('routine_result_error');
      trackRoutineEvent('routine_result');
      persistState();
      renderContextChips(body);
      body.scrollTop = body.scrollHeight;
    }

    async function renderProductRecommendations(container, recommendations) {
      container.replaceChildren();
      var states = [];
      for (var i = 0; i < recommendations.length; i += 1) {
        try {
          states.push(await resolveCanonicalProduct(recommendations[i]));
        } catch (error) {
          var unavailable = normalizeRecommendation(recommendations[i]);
          if (unavailable.handle) {
            states.push({
              handle: unavailable.handle,
              title: unavailable.handle,
              url: productUrl(unavailable.handle),
              image: '',
              variants: [],
              selectedVariantId: '',
              role: unavailable.role,
              why: unavailable.why,
              availability: 'unknown'
            });
          }
        }
      }
      visibleProducts = states;
      var productGrid = node('div', null, 'ask-seyune-products');
      states.forEach(function (state) { renderProductCard(productGrid, state); });
      container.appendChild(productGrid);
      renderCommerceFooter(container, states);
      persistState();
      renderContextChips(body);
      body.scrollTop = body.scrollHeight;
    }

    function renderSources(container, sources) {
      container.replaceChildren();
      if (!Array.isArray(sources) || !sources.length) return;
      var section = node('section', null, 'ask-seyune-sources');
      section.appendChild(node('p', 'Sources', 'ask-seyune-sources__title'));
      var list = node('ul', null, 'ask-seyune-sources__list');
      sources.slice(0, 3).forEach(function (source) {
        var link = node('a', source.title, 'ask-seyune-sources__link');
        link.href = source.url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        var item = node('li', null, 'ask-seyune-sources__item');
        item.appendChild(link);
        list.appendChild(item);
      });
      section.appendChild(list);
      container.appendChild(section);
    }

    function renderHome() {
      body.replaceChildren();
      body.appendChild(node('p', 'I am here to help you make sense of your skincare - gently and practically. Choose a starting point, or write your own question.', 'ask-seyune-welcome'));
      if (productContext) {
        var contextNote = node('p', 'Looking at: ' + productContext.title, 'ask-seyune-product-context');
        contextNote.dataset.askProductHandle = productContext.handle;
        body.appendChild(contextNote);
      }
      var wrap = node('div', null, 'ask-seyune-starters');
      starters.forEach(function (starter) {
        var starterLabel = productContext ? ({ routine: 'Build around this product', product: 'Is this right for my skin?', review: 'Find an alternative', layer: 'What can I layer it with?', chat: 'Ask anything' }[starter.key] || starter.label) : starter.label;
        var button = node('button', starterLabel, 'ask-seyune-starter');
        button.type = 'button';
        button.dataset.askStarter = starter.key;
        button.addEventListener('click', function () {
          if (starter.key === 'routine') {
            startRoutine();
            return;
          }
          if (starter.key === 'chat') {
            input.value = '';
          } else {
            input.value = starterLabel;
          }
          input.focus();
          updateComposerState();
        });
        wrap.appendChild(button);
      });
      body.appendChild(wrap);
      updateComposerState();
    }

    function renderClarification(clarification) {
      body.replaceChildren();
      body.appendChild(node('p', 'Before I continue, I want to make sure I understand the context.', 'ask-seyune-welcome'));
      body.appendChild(node('p', clarification.question, 'ask-seyune-question'));
      var choices = node('div', null, 'ask-seyune-clarification');
      clarification.options.forEach(function (option) {
        var button = node('button', option.label, 'ask-seyune-clarification__choice');
        button.type = 'button';
        button.dataset.askClarification = option.id;
        button.addEventListener('click', function () {
          resolveClarification(option.id);
        });
        choices.appendChild(button);
      });
      body.appendChild(choices);
      input.value = '';
      updateComposerState();
      body.scrollTop = body.scrollHeight;
    }

    function resolveClarification(choice) {
      if (busy) return;
      history = [];
      profile = {};
      pendingProfile = null;
      activeProfile = null;
      visibleProducts = [];
      cartSnapshot = null;
      clearPersistedState();
      step = 0;
      if (choice === 'personal_health') {
        startRoutine();
        return;
      }
      if (choice === 'general_product') {
        body.replaceChildren();
        appendMessage('Please send a new general product or ingredient question without personal health or prescription details. I will not send the earlier message or rewrite it for AI.', 'assistant');
        input.value = '';
        input.focus();
        updateComposerState();
      }
    }

    function startRoutine() {
      routineMode = true;
      step = 0;
      profile = {};
      pendingProfile = null;
      body.replaceChildren();
      trackRoutineEvent('routine_start');
      renderQuestion();
    }

    function finishRoutine() {
      pendingProfile = cloneProfile(profile);
      input.value = '';
      renderLoading('Building your routine...', 'SEYUNE is considering the details you selected.');
      updateComposerState();
      void sendCurrent();
    }

    function advance(choice) {
      var question = questions[step];
      if (question.multiple) {
        profile[question.key] = profile[question.key] || [];
        if (choice[0] === 'none') profile[question.key] = [];
        else if (profile[question.key].indexOf(choice[0]) === -1) profile[question.key].push(choice[0]);
        else profile[question.key] = profile[question.key].filter(function (value) { return value !== choice[0]; });
        return;
      }
      profile[question.key] = choice[0];
    }

    function renderQuestion() {
      var question = questions[step];
      body.replaceChildren();
      body.appendChild(node('p', 'Question ' + (step + 1) + ' of ' + questions.length, 'ask-seyune-meta'));
      body.appendChild(node('p', question.prompt, 'ask-seyune-question'));
      if (question.key === 'flags') body.appendChild(node('p', 'Safety answers are used by SEYUNE to filter recommendations and are sent to the SEYUNE Worker, not directly to the AI provider.', 'ask-seyune-safety-note'));

      var choices = node('div', null, 'ask-seyune-choices');
      var navigation = node('div', null, 'ask-seyune-question-nav');
      var backButton = node('button', 'Back', 'ask-seyune-back');
      backButton.type = 'button';
      backButton.disabled = step === 0;
      backButton.addEventListener('click', function () {
        if (step > 0) {
          step -= 1;
          renderQuestion();
        }
      });
      navigation.appendChild(backButton);
      var continueButton = node('button', 'Continue', 'ask-seyune-continue');
      continueButton.type = 'button';

      function hasAnswer() {
        if (question.multiple) return Array.isArray(profile[question.key]);
        return Boolean(profile[question.key]);
      }

      continueButton.disabled = !hasAnswer();
      continueButton.addEventListener('click', function () {
        if (!hasAnswer()) return;
        trackRoutineEvent('routine_question_complete');
        step += 1;
        if (step < questions.length) renderQuestion();
        else finishRoutine();
      });

      question.choices.forEach(function (choice) {
        var button = node('button', choice[1], 'ask-seyune-choice');
        button.type = 'button';
        button.dataset.askChoice = choice[0];
        var selectedInitially = question.multiple
          ? Array.isArray(profile[question.key]) && (choice[0] === 'none'
            ? profile[question.key].length === 0
            : profile[question.key].indexOf(choice[0]) !== -1)
          : profile[question.key] === choice[0];
        button.setAttribute('aria-pressed', String(selectedInitially));
        button.classList.toggle('ask-seyune-choice--selected', selectedInitially);
        button.addEventListener('click', function () {
          advance(choice);
          var selectedValues = Array.isArray(profile[question.key]) ? profile[question.key] : [];
          choices.querySelectorAll('button').forEach(function (other) {
            var otherChoice = other.dataset.askChoice;
            var selected = question.multiple
              ? (otherChoice === 'none' ? selectedValues.length === 0 : selectedValues.indexOf(otherChoice) !== -1)
              : otherChoice === profile[question.key];
            other.setAttribute('aria-pressed', String(selected));
            other.classList.toggle('ask-seyune-choice--selected', selected);
          });
          continueButton.disabled = !hasAnswer();
        });
        choices.appendChild(button);
      });
      body.appendChild(choices);
      navigation.appendChild(node('span', '', 'ask-seyune-question-nav__spacer'));
      navigation.appendChild(continueButton);
      body.appendChild(navigation);
    }

    function renderLoading(copy, detail) {
      body.replaceChildren();
      var loading = node('div', null, 'ask-seyune-loading');
      loading.appendChild(node('span', null, 'ask-seyune-loading__indicator'));
      loading.appendChild(node('p', copy, 'ask-seyune-loading__copy'));
      if (detail) loading.appendChild(node('p', detail, 'ask-seyune-loading__detail'));
      body.appendChild(loading);
    }

    function renderContextChips(container) {
      var existing = container.querySelector('.ask-seyune-context-chips');
      if (existing) existing.remove();
      var actions = [];
      var searchable = visibleProducts.map(function (product) {
        return (product.title + ' ' + product.role).toLowerCase();
      }).join(' ');
      if (searchable.indexOf('sunscreen') !== -1 || searchable.indexOf('spf') !== -1) actions.push({ label: 'Show sunscreens', kind: 'question' });
      if (searchable.indexOf('moistur') !== -1 || searchable.indexOf('cream') !== -1) actions.push({ label: 'Show moisturizers', kind: 'question' });
      if (visibleProducts.length > 1) actions.push({ label: 'More affordable options', kind: 'question' });
      if (!routineMode && addableStates(visibleProducts).length) actions.push({ label: 'Add routine to cart', kind: 'add' });
      if (routineMode && visibleProducts.length) actions.push({ label: 'Ask a question', kind: 'chat' });
      if (cartSnapshot && Number(cartSnapshot.item_count) > 0) {
        actions.push({ label: 'View bag', kind: 'link', href: cartUrl() });
        actions.push({ label: 'Ready to checkout', kind: 'checkout' });
      }
      actions = actions.slice(0, 4);
      if (!actions.length) return;
      var wrap = node('div', null, 'ask-seyune-context-chips');
      if (routineMode) {
        wrap.classList.add('ask-seyune-context-chips--secondary');
        wrap.appendChild(node('p', 'Need more help?', 'ask-seyune-context-chips__heading'));
      }
      actions.forEach(function (action) {
        if (action.kind === 'link') {
          var link = node('a', action.label, 'ask-seyune-context-chip');
          link.href = action.href;
          wrap.appendChild(link);
          return;
        }
        if (action.kind === 'checkout') {
          var checkoutForm = node('form', null, 'ask-seyune-checkout-chip');
          checkoutForm.method = 'post';
          checkoutForm.action = cartUrl();
          var checkoutButton = node('button', action.label, 'ask-seyune-context-chip');
          checkoutButton.type = 'submit';
          checkoutButton.name = 'checkout';
          checkoutForm.appendChild(checkoutButton);
          wrap.appendChild(checkoutForm);
          return;
        }
        if (action.kind === 'chat') {
          button.addEventListener('click', function () {
            routineMode = false;
            renderHome();
            input.focus();
          });
          wrap.appendChild(button);
          return;
        }
        var button = node('button', action.label, 'ask-seyune-context-chip');
        button.type = 'button';
        if (action.kind === 'question') {
          button.addEventListener('click', function () {
            if (busy) return;
            input.value = action.label;
            updateComposerState();
            sendCurrent();
          });
        } else {
          button.addEventListener('click', function () {
            var result = node('p', '', 'ask-seyune-cart-result');
            wrap.appendChild(result);
            addStatesToCart(visibleProducts, button, result);
          });
        }
        wrap.appendChild(button);
      });
      container.appendChild(wrap);
    }

    function normalizeIntent(text) {
      return String(text || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    }

    function recordLocalExchange(text, reply) {
      appendMessage(text, 'user');
      appendMessage(reply, 'assistant');
      pushHistory({ role: 'user', content: text });
      pushHistory({ role: 'assistant', content: reply });
      input.value = '';
      updateComposerState();
      renderContextChips(body);
    }

    async function handleLocalIntent(text) {
      var normalized = normalizeIntent(text);
      if (!normalized) return false;
      if (/\b(shipping|delivery)\b/.test(normalized)) {
        recordLocalExchange(text, 'Shipping is calculated at checkout.');
        return true;
      }
      if (/\bcheckout\b/.test(normalized) && cartSnapshot && Number(cartSnapshot.item_count) > 0) {
        recordLocalExchange(text, 'Your bag is ready when you are. Use Ready to checkout below.');
        return true;
      }
      if (!/\badd\b/.test(normalized) || !/\bcart\b/.test(normalized)) return false;
      if (!visibleProducts.length) return false;
      var states = visibleProducts;
      if (!/\b(all|routine|everything)\b/.test(normalized)) {
        var number = normalized.match(/\b(?:product )?([0-9]+)\b/);
        var query = normalized.replace(/\b(add|to|cart|product|the|please)\b/g, ' ').replace(/\s+/g, ' ').trim();
        var matches = number
          ? states.filter(function (_, index) { return String(index + 1) === number[1]; })
          : states.filter(function (state) {
            var title = normalizeIntent(state.title);
            return query && (title === query || title.indexOf(query) !== -1 || query.indexOf(title) !== -1);
          });
        if (matches.length !== 1) {
          recordLocalExchange(text, matches.length > 1
            ? 'Which visible product would you like me to add? You can use its name or number.'
            : 'I could not match that to one visible product. Please use the product card or name a visible item.');
          return true;
        }
        states = matches;
      }
      appendMessage(text, 'user');
      input.value = '';
      var wrap = node('div', null, 'ask-seyune-assistant');
      var reply = node('p', 'Adding the selected item to your bag...', 'ask-seyune-message ask-seyune-message--assistant');
      var action = node('div', null, 'ask-seyune-cart-actions');
      var button = node('button', 'Add to cart', 'ask-seyune-continue');
      button.type = 'button';
      var result = node('p', '', 'ask-seyune-cart-result');
      action.append(button, result);
      wrap.append(reply, action);
      body.appendChild(wrap);
      await addStatesToCart(states, button, result);
      pushHistory({ role: 'user', content: text });
      pushHistory({ role: 'assistant', content: reply.textContent + ' ' + result.textContent });
      updateComposerState();
      renderContextChips(body);
      return true;
    }

    function prewarmTurnstile() {
      if (turnstileGate && typeof turnstileGate.prewarm === 'function') turnstileGate.prewarm().catch(function () {});
    }

    async function getTurnstileToken(signal) {
      try {
        return await turnstileGate.getToken(signal);
      } catch (error) {
        if (error && error.code === 'turnstile_busy' && typeof turnstileGate.waitForPrewarm === 'function') {
          setStatus('Securing this request...', true);
          await turnstileGate.waitForPrewarm();
          return turnstileGate.getToken(signal);
        }
        throw error;
      }
    }

    function pushHistory(message) {
      history.push({
        role: message.role,
        content: Array.from(message.content).slice(0, 500).join('')
      });
      if (history.length > 12) history = history.slice(-12);
      persistState();
    }

    function clearRequest() {
      if (activeController) activeController.abort();
      activeController = null;
      turnstileGate.cancel();
      busy = false;
      setStatus('', false);
      updateComposerState();
    }

    async function sendCurrent() {
      var text = input.value.trim();
      var requestText = routineMode ? 'Find My Routine' : (text || 'Build my full AM & PM routine.');
      var requestProfile = pendingProfile || activeProfile;
      var isBuilder = Boolean(pendingProfile);
      if (busy || (!text && !pendingProfile)) return;
      if (text && await handleLocalIntent(text)) return;

      if (host.dataset.enabled !== 'true' || !host.dataset.endpoint || !host.dataset.turnstileSiteKey) {
        appendMessage('Ask Seyune is prepared locally but remains disabled until the protected SEYUNE Worker and Turnstile configuration are ready.', 'assistant');
        return;
      }

      var controller = new AbortController();
      activeController = controller;
      busy = true;
      updateComposerState();
      setStatus(isBuilder ? 'Preparing your routine...' : 'Preparing a response...', true);

      var token;
      var assistantWrap = null;
      var recommendations = [];
      var sources = [];
      try {
        token = await getTurnstileToken(controller.signal);
        if (controller.signal.aborted) throw new Error('cancelled');
        if (!consentGiven) consentGiven = consentStore.grant();

        var outgoing = routineMode
          ? [{ role: 'user', content: 'Find My Routine' }]
          : history.slice(-11).concat([{ role: 'user', content: requestText }]);
        appendMessage(requestText, 'user');
        input.value = '';

        assistantWrap = node('div', null, 'ask-seyune-assistant');
        var assistantText = node('p', '', 'ask-seyune-message ask-seyune-message--assistant');
        var productWrap = node('div', null, 'ask-seyune-products');
        var sourceWrap = node('div', null, 'ask-seyune-sources-wrap');
        assistantWrap.append(assistantText, productWrap, sourceWrap);
        body.appendChild(assistantWrap);
        body.scrollTop = body.scrollHeight;

        var routineAnswers = routineMode ? {
          skinType: profile.type,
          sensitivity: profile.sensitivity,
          goal: profile.goal,
          safety: (profile.flags || []).map(function (flag) {
            return flag === 'condition' ? 'diagnosed_condition' : flag === 'meds' ? 'prescription_topical_medication' : flag;
          })
        } : null;
        var result = await adapter.send({
          messages: outgoing,
          profile: routineMode ? null : requestProfile,
          turnstileToken: token,
          productContext: productContext,
          conversationId: conversationId,
          mode: routineMode ? 'find_my_routine' : null,
          routineAnswers: routineAnswers,
          aiProcessingConsent: true
        }, {
          signal: controller.signal,
          onEvent: function (event) {
            if (event.type === 'text') assistantText.textContent += event.delta;
            if (event.type === 'product') recommendations.push(event);
            if (event.type === 'source') sources.push(event);
            body.scrollTop = body.scrollHeight;
          }
        });

        if (result.routineResult) {
          assistantWrap.remove();
          var routineWrap = node('div', null, 'ask-seyune-routine-result');
          body.appendChild(routineWrap);
          renderRoutineResult(routineWrap, result.routineResult);
          pendingProfile = null;
          activeProfile = null;
        } else if (recommendations.length) await renderProductRecommendations(productWrap, recommendations);
        if (!result.routineResult && result.sources.length) renderSources(sourceWrap, result.sources);

        if (result.routineResult) {
          persistState();
        } else if (result.clarification) {
          assistantWrap.remove();
          renderClarification(result.clarification);
        } else if (result.fallback) {
          assistantWrap.remove();
          appendMessage(failureMessage(result.failureClass, null), 'ask-seyune-assistant');
        } else if (!result.text && !result.routineResult) {
          assistantWrap.remove();
          throw new Error('empty_response');
        } else {
          pushHistory({ role: 'user', content: requestText });
          pushHistory({ role: 'assistant', content: result.text });
          activeProfile = requestProfile;
          persistState();
          pendingProfile = null;
        }
      } catch (error) {
        if (assistantWrap) assistantWrap.remove();
        if (error && error.code === 'cancelled') {
          setStatus('', false);
        } else if (!controller.signal.aborted) {
          appendMessage(failureMessage(null, error), 'ask-seyune-assistant');
        }
      } finally {
        try {
          turnstileGate.reset();
        } catch (error) {
          // Turnstile cleanup must not block final UI state restoration.
        }
        if (activeController === controller) activeController = null;
        if (dialog.open) prewarmTurnstile();
        busy = false;
        setStatus('', false);
        updateComposerState();
      }
    }

    function renderRestoredState() {
      body.replaceChildren();
      history.forEach(function (message) { appendMessage(message.content, message.role); });
      if (visibleProducts.length) {
        var wrap = node('div', null, 'ask-seyune-products');
        body.appendChild(wrap);
        renderProductRecommendations(wrap, visibleProducts.slice());
      }
      renderContextChips(body);
      updateComposerState();
    }

    function readProductContext(trigger, context) {
      var handle = context && context.handle
        ? context.handle
        : trigger && trigger.dataset && trigger.dataset.askProductHandle;
      var title = context && context.title
        ? context.title
        : trigger && trigger.dataset && trigger.dataset.askProductTitle;
      if (typeof handle !== 'string' || typeof title !== 'string' || !handle || !title) return null;
      return { handle: handle, title: title };
    }

    function open(trigger, mode, context) {
      lastTrigger = trigger || lastTrigger;
      productContext = readProductContext(trigger, context);
      if (!dialog.open) dialog.showModal();
      if (mode === 'routine') {
        startRoutine();
      } else if (productContext || !restoredState) {
        routineMode = false;
        renderHome();
      } else {
        routineMode = false;
        renderRestoredState();
      }
      prewarmTurnstile();
      updateComposerState();
      body.focus();
    }

    function close() {
      clearRequest();
      if (dialog.open) dialog.close();
    }

    input.addEventListener('input', updateComposerState);
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      sendCurrent();
    });
    host.querySelector('[data-ask-close]').addEventListener('click', close);
    host.querySelector('[data-ask-reset]').addEventListener('click', function () {
      clearRequest();
      profile = {};
      pendingProfile = null;
      activeProfile = null;
      step = 0;
      history = [];
      visibleProducts = [];
      cartSnapshot = null;
      restoredState = false;
      clearPersistedState();
      conversationId = createConversationId();
      routineMode = false;
      renderHome();
    });
    dialog.addEventListener('close', function () {
      clearRequest();
      if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    });

    restoredState = restorePersistedState();
    if (!restoredState) persistState();
    window.AskSeyune = { open: open, close: close };
  }

  function bindTriggers() {
    document.querySelectorAll('[data-ask-open]').forEach(function (button) {
      if (button.dataset.askBound === '1') return;
      button.dataset.askBound = '1';
      button.addEventListener('click', function () {
        if (window.AskSeyune && typeof window.AskSeyune.open === 'function') {
          var context = button.dataset.askProductHandle && button.dataset.askProductTitle
            ? { handle: button.dataset.askProductHandle, title: button.dataset.askProductTitle }
            : null;
          window.AskSeyune.open(button, button.dataset.askMode || 'chat', context);
        }
      });
    });
  }

  function boot() {
    var host = document.querySelector('ask-seyune[data-ask-host="true"]');
    if (host) init(host);
    bindTriggers();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
}());
